// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"jO","contentFrame":"jP","buttonGroup":"jQ","button":"jR","header":"jS","text":"jT","contentImage":"jU"};